import { useAuthContext } from './useAuthContext';
import { getManageSubscriptionPath } from '/src/features/_global/utils';
import { isSemrush } from '/src/utils/semrush';

export function useManageSubscriptionPath() {
  const { currentAccount } = useAuthContext();
  const isShopifyUser = Boolean(currentAccount?.isShopifyUser);

  return getManageSubscriptionPath(isShopifyUser, isSemrush);
}
